// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_asM","cls2":"Configuration-cls2_tss Configuration-cls1_asM"};